import React from 'react';
import { escapeRegExp } from 'lodash';

const colorMap = {
  yellow: '#FFFF00',
  red: '#FF0000',
};

export const getHighlightedText = (text, highlight) => {
  const escapedHighlightText = escapeRegExp(highlight);
  const parts = text.split(new RegExp(`(${escapedHighlightText})`, 'gi'));
  return (
    <span>
      {' '}
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part.toLowerCase() === highlight.toLowerCase()
              ? { backgroundColor: colorMap.yellow, color: colorMap.red }
              : {}
          }
        >
          {part}
        </span>
      ))}{' '}
    </span>
  );
};
